import { z } from 'zod/v4';

export const CompanyDocumentsDownloadRequestSchema = z
  .array(z.string().min(1, 'Document ID is required'))
  .min(1, 'At least one document ID is required')
  .max(100, 'Maximum 100 document IDs allowed per request');

export type CompanyDocumentsDownloadRequest = z.infer<
  typeof CompanyDocumentsDownloadRequestSchema
>;

export const CompanyDocumentsDownloadResponseSchema = z.object({
  /** Read-only link to the zip. */
  url: z.string().min(1, 'Download URL is required'),
  id: z.string().min(1, 'Download ID is required'),
});

export type CompanyDocumentsDownloadResponse = z.infer<
  typeof CompanyDocumentsDownloadResponseSchema
>;
